import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useWindowSize } from '@/hooks/useWindowSize';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { EMPTY_DASH } from '@/helpers/constants';
import { StreakStatus } from '../../components/StreakStatus';
import s from './index.module.scss';

const id = MODAL_IDS.streak_activity_detail;

export const StreakActivityDetailModal = () => {
  const { modalIds, data } = useModal();
  return modalIds[id] && data && <Modal data={data} />;
};

const Modal = ({ data }) => {
  const { closeModal } = useModal();
  const { isMobile } = useWindowSize();
  const { t } = useTranslation('streak');

  const content = (
    <div className={classnames(s.modal, 'scr_modal_grid')}>
      <div className="f-h3 f-500">{t('activity_detail_modal.details')}</div>
      <div className={s.content}>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.round')}
          </div>
          <div className="f-small-accent">
            {prettyDate(data.round_date, 'MMMM YYYY')}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.topped_up')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.topped_up, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.withdrawn')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.withdrawn, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.net_cash_flow')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.net_cash_flow, { decimalPlaces: 2 })}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.round_status')}
          </div>
          <div className="f-small-accent">
            <StreakStatus status={data.round_status} />
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.income_increase')}
          </div>
          <div className="f-small-accent">
            {Number(data.income_increase)
              ? `${data.income_increase}%`
              : EMPTY_DASH}
          </div>
        </div>
        <div className={s.row}>
          <div className="f-small-regular">
            {t('activity_detail_modal.net_cash_flow_bonus')}
          </div>
          <div className="f-small-accent">
            {prettyFloatMoney(data.net_cash_flow_bonus, { decimalPlaces: 2 })}
          </div>
        </div>
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : null;
};
